import { combineReducers } from 'redux'

import oeqReducer from './oeqReducer'
import mcqReducer from './mcqReducer'

const creationToolReducer = combineReducers({
	oeq: oeqReducer,
	mcq: mcqReducer,
})

export default creationToolReducer
